import { useTranslation } from "react-i18next";
import {
  resolveActiveWeddingEvent,
  eventSourceFromRow,
  weddingEventName,
  type ActiveWeddingEvent,
  type WeddingEventRow,
  type LanguageCode,
} from "@wedding/shared";

/**
 * Guest tarafının etkinlik yardımcıları.
 *
 * "Hangi etkinliğe geri sayıyoruz" sorusunun cevabı `@wedding/shared`'daki
 * `resolveActiveWeddingEvent` — en yakın gelecekteki etkinlik. Kına geçince
 * sayaç kendiliğinden düğüne döner. Burada yalnız i18n bağlaması var.
 */

function langOf(language: string): LanguageCode {
  const code = language.slice(0, 2);
  return (["tr", "en", "fr", "es"].includes(code) ? code : "tr") as LanguageCode;
}

/** Etkinliğin insan-okur adı ("Kına", "Düğün", serbest metin). */
export function useEventName(): (event: ActiveWeddingEvent) => string {
  const { i18n } = useTranslation();
  return (event) => weddingEventName(event, langOf(i18n.language));
}

/** Aktif hedef etkinlik — `null` ise düğünde hiç tarih yok. */
export function useActiveEvent(row: WeddingEventRow | null | undefined): ActiveWeddingEvent | null {
  return resolveActiveWeddingEvent(eventSourceFromRow(row));
}

export { langOf };
